import React, { memo } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

const propTypes = {
  currentScore: PropTypes.number.isRequired,
  maxScore: PropTypes.number
};
function SecurityPostureSecureScore({ currentScore, maxScore }) {
  const intl = useIntl();
  const formatPercentage = (score) => intl.formatNumber(score / 100, {
    style: "percent",
    maximumFractionDigits: 2
  })

  if (currentScore == null && maxScore == null) {
    return null
  }

  return maxScore == null ? (
    <span>{formatPercentage(currentScore)}</span>
  ) : (
    <>
      <span>{currentScore}</span>
      <span className="Uic-SecurityPostureTable-maxScore">
        /{formatPercentage(maxScore)}
      </span>
    </>)

}

SecurityPostureSecureScore.propTypes = propTypes;


export default memo(SecurityPostureSecureScore);
